import socket from './socket'

export default {
  install(Vue, options = {}) {
    if (!options.store) {
      console.error('[kefuSocket] Vue.use 时必须传入 store')
      return
    }

    socket.init({
      store: options.store
    })

    Vue.prototype.$kefuSocket = socket
  }
}
